import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="mx-auto max-w-3xl px-6 lg:px-10 py-24 text-center">
      <XCircle className="w-14 h-14 text-white/40 mx-auto" />
      <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-white/50 mt-6">// TRANSACTION CANCELLED</div>
      <h1 className="font-display font-black text-4xl tracking-tighter mt-3">No worries.</h1>
      <p className="mt-3 text-white/70">Your card was not charged.</p>
      <Link to="/" className="inline-block mt-6 bg-[#FF3366] text-white font-mono uppercase tracking-[0.2em] text-xs px-5 py-3">Back to store →</Link>
    </div>
  );
}
